import { Button, Center, Flex, Heading, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"
import { ButtonBack, Layout } from "../../../components"
import { Temporizador } from "../components";
import { entregaActions } from "../reducer";
import { useEffect, useState } from 'react';
import { FiArrowDownLeft, FiCheck, FiCornerRightDown } from "react-icons/fi";
import { DadosComplementaresButton, NotasFiscaisDaEntrega } from "../../carga/components";
import { buscaCoordenadasAtuais } from "../../../utils/geolocalizacao";
import useEntregaDaRota from "../../../hooks/useEntregaDaRota";

const OpcoesEntregaGrupo = () => {
  const { j14_ukey, j10_ukey, carga, entrega } = useEntregaDaRota();

  const [passo, setPasso] = useState(1);
  const [buscandoChegada, setBuscandoChegada] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const registraChegadaNoCliente = async () => {
    setBuscandoChegada(true);

    const { latitude, longitude } = await buscaCoordenadasAtuais({
      altaPrecisao: true,
    });

    setBuscandoChegada(false);

    dispatch(entregaActions.registraChegadaNoCliente({
      e_transbordo: false,
      j14_ukey: j14_ukey as string,
      j10_ukey: (entrega?.j10_ukey_rota || j10_ukey) as string,
      latitude,
      longitude,
    }));

    setPasso(2);
  }

  const e_retira = carga?.e_retira == '1';

  useEffect(() => {
    if (!e_retira || !entrega) return;

    dispatch(entregaActions.registraChegadaNoCliente({
      e_transbordo: false,
      j14_ukey: j14_ukey as string,
      j10_ukey: (entrega.j10_ukey_rota || j10_ukey) as string,
    }));

    navigate(`/entrega/grupo/${j14_ukey}/${j10_ukey}/opcoes/entregar`, { replace: true });
  }, [e_retira, !!entrega]);

  const prosseguir = (to: 'entrega' | 'devolucao') => {
    navigate(`/entrega/grupo/${j14_ukey}/${j10_ukey}/opcoes/${to === 'entrega' ? 'entregar' : 'devolucao'}`);
  }

  return (
    <Layout showFooter={true} isLoading={false} title={
      <>
        <ButtonBack />
        {passo > 1 && <Temporizador />}
      </>
    }>
      <Center mt={8}>
        <Heading>Finalizar Entrega</Heading>
      </Center>
      <Center mx={4} mb={2} mt={2} textAlign="center">
        <Heading size="sm">{entrega ? entrega.razao_social : 'Entrega não encontrada'}</Heading>
      </Center>
      {entrega && (
        <Flex mx={2} mb={8}>
          <NotasFiscaisDaEntrega entrega={entrega} />
        </Flex>
      )}

      {entrega && (
        <Flex width="full" wrap="wrap" >
          {passo === 1 &&
            <Button size="xl" onClick={registraChegadaNoCliente} mx={2} colorScheme="blue" padding={6} width="full" isLoading={buscandoChegada} isDisabled={buscandoChegada}>
              <Text fontSize="18">REGISTRAR CHEGADA NO CLIENTE</Text>
              <Flex ml={2} >
                <FiCornerRightDown color="white" fontSize="1.5rem" />
              </Flex>
            </Button>
          }
          {passo === 2 &&
            <Flex width="full" direction="column" mx={2}>
              <Button size="xl" mb={4} colorScheme="green" padding={6} width="full" onClick={() => prosseguir('entrega')}>
                <Text fontSize="20" mr={2}>CONCLUIR {entrega.tem_reentrega ? 'REENTREGA' : 'ENTREGA'}</Text>
                <Flex position="absolute" right={3} padding={1} borderRadius={25} bg="white">
                  <FiCheck color="green" fontSize="1.8rem" />
                </Flex>
              </Button>
              <Button size="xl" mb={4} colorScheme="yellow" padding={6} width="full" onClick={() => prosseguir('devolucao')}>
                <Text fontSize="20" mr={2}>
                  CLIENTE RECUSOU A ENTREGA <br /> <small>DEVOLUÇÃO TOTAL DA ENTREGA</small>
                </Text>
                <Flex position="absolute" right={3} padding={1} borderRadius={25} bg="white">
                  <FiArrowDownLeft color="yellow" fontSize="1.8rem" />
                </Flex>
              </Button>

              <Flex direction="column" gap={2}>
                {entrega.notas.map((nota) => (
                  <DadosComplementaresButton
                    key={nota.j10_ukey}
                    label={entrega.notas.length === 1 ? 'DETALHES' : `Detalhes NF ${nota.nota_numero}`}
                    vendedor={{ vendedor_codigo: nota.vendedor_codigo, vendedor_nome: nota.vendedor_nome, vendedor_celular: nota.vendedor_celular }}
                    dados_complementares={nota}
                    pessoa={nota.cliente_razao_social}
                    produtos={nota.produtos}
                  />
                ))}
              </Flex>
            </Flex>
          }
        </Flex>
      )}
    </Layout>
  )
}

export default OpcoesEntregaGrupo;
